import config from '@/const/config';
import { easyPost } from './utils';

// 邀请明细分组展示接口
// eslint-disable-next-line import/prefer-default-export
export const mgmInterface = easyPost('activity.dispatcher.distribute', {
  api: config.MARKET_API,
  risk: true,
});

// 跑马灯奖品列表
export const runHorse = easyPost('user.mgm.prizeList', { risk: true });

// 生成短链哈口令
export const generate = easyPost('common.helloCommand.generate', { risk: true });

// 所有的配置文件
export const mgmConfig = easyPost('user.mgm.config', { risk: true });
